/* Far Afield — Klaviyo BIS on the existing mobile purchase control.
   Klaviyo owns the subscription modal. This only forwards clicks from the
   theme's ONE sticky CTA to Klaviyo's real injected trigger when sold out.
   Never create a second subscription flow or duplicate product form. */
(() => {
  const selector = '.main-product product-info';
  const mobile = window.matchMedia('(max-width: 749px)');

  function init(root) {
    if (root.dataset.faBisBridgeReady) return;
    root.dataset.faBisBridgeReady = 'true';
    const formSubmit = () => root.querySelector('.product__buy-buttons .product-form__submit');
    const stickyButton = () => root.querySelector('.product__sticky-cart .product-bar__submit');
    const klaviyoTrigger = () => root.querySelector('.product__buy-buttons .klaviyo-bis-trigger');
    let pending = false;
    // After Klaviyo has controlled the sticky CTA, mirror Shopify's real
    // purchase state until its variant transition has settled.
    let returningFromBis = false;

    function soldOut() {
      const variant = root.querySelector('product-variant-selects [data-selected-variant]');
      try {
        const value = JSON.parse(variant?.textContent || 'null');
        return Boolean(value && value.available === false);
      } catch { return false; }
    }

    function sync() {
      pending = false;
      if (!root.isConnected) return;
      const button = stickyButton();
      const source = klaviyoTrigger();
      const chosen = root.dataset.faSizeChosen !== 'false' || root.dataset.faHasAvailableVariant === 'false';
      const ready = mobile.matches && !!button && !!source && soldOut() && chosen;
      root.classList.toggle('fa-pdp-bis-proxy-ready', ready);
      if (!button) return;
      // Shopify replaces sticky bar markup on variant changes; change only
      // the label and disabled state while the original Klaviyo action exists.
      if (ready) {
        returningFromBis = true;
        button.disabled = false;
        button.dataset.faBisProxyLabel = 'true';
        const label = button.querySelector('span');
        if (label && label.textContent.trim() !== 'Notify me when available') {
          label.textContent = 'Notify me when available';
        }
      } else if (returningFromBis) {
        // Variant JSON and Shopify purchase markup update in separate DOM steps.
        // Keep the sticky state in sync through that transition, not only on
        // the first frame (which may still contain the previous Sold out label).
        delete button.dataset.faBisProxyLabel;
        const sourceButton = formSubmit();
        const desiredText = root.dataset.faSizeChosen === 'false'
          ? 'Choose size' : (sourceButton?.querySelector('span')?.textContent.trim() || 'Sold out');
        const label = button.querySelector('span');
        if (label && label.textContent.trim() !== desiredText) label.textContent = desiredText;
        const desiredDisabled = sourceButton?.disabled ?? true;
        if (button.disabled !== desiredDisabled) button.disabled = desiredDisabled;
      }
    }
    function schedule() {
      if (!pending) { pending = true; requestAnimationFrame(sync); }
    }

    root.addEventListener('click', event => {
      const button = event.target.closest?.('.product__sticky-cart .product-bar__submit');
      if (!button || !root.classList.contains('fa-pdp-bis-proxy-ready')) return;
      const trigger = klaviyoTrigger();
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      trigger.click();
    }, true);

    // Observe only the parts Shopify/Klaviyo replace. No timers or polling.
    let observer;
    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      // Avoid observing the full product gallery/recommendation tree.
      const picker = root.querySelector('.product__variant-picker');
      const purchase = root.querySelector('.product__buy-buttons');
      const bar = root.querySelector('.product__sticky-cart');
      if (picker) observer.observe(picker, { childList: true, subtree: true });
      if (purchase) observer.observe(purchase, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      if (bar) observer.observe(bar, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
    root.addEventListener('change', schedule, true);
    mobile.addEventListener('change', schedule);
    // The editor replaces sections without a full navigation. Release observers
    // and the media-query subscription so stale product nodes aren't retained.
    function cleanup(event) {
      if (event.target !== root && !event.target.contains(root)) return;
      observer?.disconnect();
      mobile.removeEventListener('change', schedule);
      document.removeEventListener('shopify:section:unload', cleanup);
    }
    document.addEventListener('shopify:section:unload', cleanup);
    schedule();
  }

  document.querySelectorAll(selector).forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.(selector).forEach(init);
  });
})();
